import { createTheme } from '@material-ui/core/styles'

const theme = createTheme({
	typography: {
		fontFamily: ['Jost', 'sans-serif'].join(','),
	},
})

export default theme
